export const QueryStringToJSONObject = queryString => {
  const result = {};
  const queryStringParts = queryString.split('&');
  queryStringParts.forEach(part => {
    const key = part.split('=')[0];
    const value = decodeURIComponent(part.split('=')[1]);
    if(result[key]){
      if(Array.isArray(result[key])){
        result[key].push(value)
      }else{
        result[key] = [result[key], value]
      }
    }else{
      if(value === 'no'){
        result[key] = false;
      }else if(value === 'yes'){
        result[key] = true;
      }else{
        result[key] = value;
      }
    }
  });
  if(result.selectedYears){
    if(Array.isArray(result.selectedYears)){
      result.selectedYears = [...result.selectedYears].map(year => parseInt(year));
    }else{
      result.selectedYears = [parseInt(result.selectedYears)]
    }
  }
  if(result.productTestTypes){
    if(Array.isArray(result.productTestTypes)){
      result.productTestTypes = [...result.productTestTypes].map(type => parseInt(type));
    }else{
      result.productTestTypes = [parseInt(result.productTestTypes)]
    }
  }
  if(result.customerStatuses){
    if(Array.isArray(result.customerStatuses)){
      result.customerStatuses = [...result.customerStatuses].map(status => parseInt(status));
    }else{
      result.customerStatuses = [parseInt(result.customerStatuses)]
    }
  }
  return result;
};